module.exports = __webpack_public_path__ + "img/homepage-quick-links-boxes-arrows-honda.26d8edc8.png";